import styled from 'styled-components';

export const Answer = styled.div`
  align-items: center;
  background: #201683;
  border: 4px solid #bfc2c7;
  clip-path: polygon(10% 0%, 90% 0%, 100% 50%, 90% 100%, 10% 100%, 0% 50%);
  color: #ffffff;
  display: flex;
  flex: 1;
  font-family: 'Oswald', sans-serif;
  font-size: 24px;
  margin: 4px 12px;
  padding: 16px 5%;
  position: relative;

  & span {
    margin-right: 16px;
  }
`;
Answer.displayName = 'Answer';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  font-family: 'Oswald', sans-serif;
  font-size: 42px;
  width: 100%;
`;
Container.displayName = 'Container';

export const Header = styled.div`
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  margin: 0 10% 8px;
`;
Header.displayName = 'Header';

export const Question = styled.div`
  background: #201683;
  border: 4px solid #bfc2c7;
  clip-path: polygon(10% 0%, 90% 0%, 100% 50%, 90% 100%, 10% 100%, 0% 50%);
  color: #ffffff;
  display: flex;
  font-family: 'Oswald', sans-serif;
  font-size: 36px;
  justify-content: center;
  margin-bottom: 16px;
  padding: 16px 9%;
`;
Question.displayName = 'Question';

export const Row = styled.div`
  display: flex;
`;
Row.displayName = 'Row';

export const Title = styled.div`
  color: #ffffff;
  font-size: 30px;
  padding: 4px 0;
`;
Title.displayName = 'Title';

export const UsersAnswered = styled.span`
  font-size: 15px;
  position: absolute;
  right: 6%;
`;
UsersAnswered.displayName = 'UsersAnswered';
